import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as DialogImg } from '@images/Survey/dialog.svg'
import handshake from '@images/Survey/handshake.svg'
import { ReactComponent as HeartImg } from '@images/Survey/heart.svg'
import { ReactComponent as ClockImg } from '@images/Survey/clock.svg'
import Action from '@ui/ActionButton'
import CirclesBackground from '@ui/CirclesBackground'
import './styles.scss'

const FirstStep = ({ name, onStart }) => {
  const { t } = useTranslation()

  return (
    <div className='flex vertical first-step-container'>
      <CirclesBackground>
        <img className='handshake' src={handshake} />
      </CirclesBackground>
      <div className='first-step'>
        <div className='first-step-title'>
          {t('Welcome')} {name}
        </div>
        <div className='first-step-subtitle'>
          {t('A few notes before you start the survey.')}
        </div>
        <div className='first-step-main'>
          <div className='flex no-wrap'>
            <div>
              <ClockImg />
            </div>
            <span>
              <strong> {t('Take your time')}:</strong>{' '}
              {t(
                'your feedback will help determine if this job is a good fit for you'
              )}
              .
            </span>
          </div>
          <div className='flex no-wrap'>
            <div>
              <HeartImg />
            </div>
            <span>
              <strong> {t('Be honest')}:</strong>{' '}
              {t(
                'employers understand that no one is perfect. Giving yourself max scores is often viewed as a red flag'
              )}
              .
            </span>
          </div>
          <div className='flex no-wrap'>
            <div>
              <DialogImg />
            </div>
            <span>
              <strong> {t('Be Thoughtful')}:</strong>{' '}
              {t(
                'your insights will likely be used to help adjust to your new role, team and company culture'
              )}
              .
            </span>
          </div>
        </div>
        <Action
          primary
          showIconOnResponsive
          onClick={onStart}
          content='Start'
          direction='right'
        />
      </div>
    </div>
  )
}

export default FirstStep
